<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Workflows</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

    <SGPTabelaComponent
      v-if="listaDeWorkflows.length"
      :colunas="colunas"
      :dados="listaDeWorkflows"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
      :filtroText="true"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Workflow"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioProcessoComponent
        :tipoFormulario="tipoFormulario"
        :workflow="workflow"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingWorkflows"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioProcessoComponent from '../components/FormularioCtrlWorkflowComponent.vue'
import moduleReload from '@/common/mixins/module-reload'

export default {
  components: { FormularioProcessoComponent },
  mixins: [moduleReload],
  name: 'CtrlWorkflowPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      workflowsSelecionados: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      workflow: {}
    }
  },
  created () {
    this.listarWorkflows();
  },
  computed: {
    ...mapGetters('ctrlWorkflow', ['listaDeWorkflows','loadingWorkflows']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        }, 
        {
          key: 'workflow',
          label: 'Nome',
          sortable: false
        },
        // {
        //   key: 'ctrl_macro_processo.processo',
        //   label: 'Macro Processo',
        //   sortable: false
        // },
        // {
        //   key: 'ctrl_tipo_hierarquia.hierarquia',
        //   label: 'Tipo de Hierarquia',
        //   sortable: false
        // },
        // {
        //   key: 'ctrl_macro_hierarquia.hierarquia',
        //   label: 'Hierarquia Pai',
        //   sortable: false
        // },
        // {
        //   key: 'ctrl_sub_hierarquia.hierarquia',
        //   label: 'Hierarquia Filho',
        //   sortable: false
        // },
        {
          key: 'tipo_aging.tipo',
          label: 'Tipo de Aging',
          sortable: false
        },
        {
          key: 'aging',
          label: 'Aging',
          sortable: false
        },
        {
          key: 'ordem',
          label: 'Ordem',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlWorkflow', 
    [
      'listarWorkflows',
      // 'listarMacroProcessos',
      'excluirWorkflows',
    ]),
    // ...mapActions('tiposHierarquias', 
    // [
    //   'listarTiposHierarquias'
    // ]),
    gerenciadorDeSelecionados (selecionados) {
      this.workflowsSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.workflow = this.workflowsSelecionados[0];
      // this.listarMacroProcessos(this.processo);
      // this.listarTiposHierarquias();
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirWorkflows(this.workflowsSelecionados);
      this.deletarDados = false;
    },

    adicionarNovo () {
      this.workflow = {};
      this.tipoFormulario = 'salvar';
      // this.listarMacroProcessos();
      // this.listarTiposHierarquias();
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    reloadData () {
      this.listarWorkflows();
    }

  }
}
</script>
